import { render, staticRenderFns } from "./EnergyGame.vue?vue&type=template&id=6fe9fd18&"
import script from "./EnergyGame.vue?vue&type=script&lang=js&"
export * from "./EnergyGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports